import { doPost, doGet, doPut } from '../../tools/axios'

export default {
  getSponsorItems () {
    return doGet('/regardItems')
  },
  getSponsorGreetings (page, perPage, sort = '') {
    return doGet(`/regardItemGreetings?page=${page}&perPage=${perPage}${sort ? '&sort=' + sort : ''}`)
  },
  sponsorItem (itemId, data) {
    return doPost(`/regardItems/${itemId}/sponsor`, data)
  },
  getSponsorExpiredData (itemId, from, to) {
    return doGet(`/regardItemSponsors/${itemId}/sentCount?from=${from}&to=${to}`)
  },
  modifySponsorGreeting (id, content) {
    return doPut(`/regardItemGreetings/${id}`, { content })
  },
  voteSponsorGreeting (id) {
    return doPost(`/regardItemGreetings/${id}/vote`)
  },
  cancelVoteSponsorGreeting (id) {
    return doPost(`/regardItemGreetings/${id}/cancel_vote`)
  },
  getGreetingDetail (id) {
    return doGet(`/regardItemGreetings/${id}`)
  }
}
